import React from "react";
import { DeleteDialog } from "../../../components";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import MakeCreditModal from "../modals/MakeCreditModal";

interface Props {
  viewModel: server.viewmodel.InvoiceV2DetailFrontModel;
  invoice?: server.dto.InvoiceV2;
}

const InvoiceV2OptionsPanel = (props: Props) => {
  const {
    optionsPanel,
    listUrl,
  } = props.viewModel;
  const { invoice = props.viewModel.details } = props;

  const [isDeleting, setIsDeleting] = React.useState(false);
  const [displayMakeCreditModal, setDisplayMakeCreditModal] = React.useState(false);

  const onDelete = async () => {
    await window.CoreApi.Invoice.Delete({ invoiceId: invoice.invoiceId });
    // We need to check the outcomeDto if there are any errors. If there are any errors, we need to show them to the user.
    // If none, we can redirect the user to the overview page.
    window.location.href = listUrl;
    setIsDeleting(false);
  };

  const canMakeCredit = site.permissions.invoice.canCreate && (invoice.lifeCycle === "completed" || invoice.lifeCycle === "pending") && !invoice.isCredit;

  return <>
    <GeneralOptionsPanel
      data={optionsPanel}
      links={[
        { text: RESX.Buttons.ListView, visible: true, href: listUrl },
        { text: RESX.Invoice.MakeCredit, visible: canMakeCredit, onClick: () => { setDisplayMakeCreditModal(true); } },
        { text: RESX.Buttons.btnDelete, visible: invoice.permissions.canDelete, onClick: () => { setIsDeleting(true); } }
      ]}
      shortcutOrder={["payment", "recipient", "show", "note"]}
    />

    <DeleteDialog
      isOpen={isDeleting}
      message={RESX.GeneralWarnings.AreYouSure}
      handleClose={() => { setIsDeleting(false); }}
      onDelete={onDelete}
    />

    {displayMakeCreditModal && <MakeCreditModal
      onClose={() => { setDisplayMakeCreditModal(false); }}
      productsByParent={props.viewModel.productsPanel.data}
      invoice={invoice}
      createCreditConcerningText={props.viewModel.createCreditConcerningText}
      canModifyPayments={props.viewModel.canModifyPayments}
    />}
  </>
};

export default InvoiceV2OptionsPanel;